var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSdnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.695,
    height: 19.546,
    viewBox: "0 0 21.695 19.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7316",
    "data-name": "Path 7316",
    d: "M-704.905,695.112v1.1a1.688,1.688,0,0,0-.036.183,8.608,8.608,0,0,1-.459,2.1,13.468,13.468,0,0,1-3.184,4.918,28.31,28.31,0,0,1-6.846,5,.65.65,0,0,1-.665-.007,30.8,30.8,0,0,1-5.758-3.967,16.237,16.237,0,0,1-3.514-4.286c-.134-.245-.253-.5-.4-.784h.268c.932,0,1.865-.007,2.8,0a.756.756,0,0,0,.771-.474c.226-.485.476-.958.727-1.459.045.084.079.144.11.206.666,1.331,1.326,2.664,2,3.99a.957.957,0,0,0,.362.39.614.614,0,0,0,.852-.351q1.005-2,2.006-4.012c.032-.065.069-.128.121-.224.256.513.5.98.724,1.458a.76.76,0,0,0,.77.476c1.518-.008,3.037,0,4.555,0a1.239,1.239,0,0,0,.293-.029.634.634,0,0,0,.47-.649.634.634,0,0,0-.551-.582,2.345,2.345,0,0,0-.275-.009c-1.335,0-2.669,0-4,0a.317.317,0,0,1-.337-.207c-.344-.711-.7-1.415-1.056-2.12a.63.63,0,0,0-.744-.379.7.7,0,0,0-.467.425q-1,2-2,3.993c-.032.063-.068.124-.114.207-.711-1.422-1.407-2.808-2.1-4.2a.675.675,0,0,0-.611-.448.671.671,0,0,0-.63.45c-.34.7-.7,1.386-1.036,2.084a.288.288,0,0,1-.3.192c-.953-.008-1.907-.01-2.86,0-.181,0-.242-.063-.283-.224a8.257,8.257,0,0,1-.262-2.915,6.691,6.691,0,0,1,2.362-4.6,5.58,5.58,0,0,1,7.321-.064c.413.339.8.712,1.2,1.07.132-.148.323-.373.527-.585a5.537,5.537,0,0,1,6.518-1.268,6.361,6.361,0,0,1,3.517,4.39C-705.021,694.3-704.976,694.711-704.905,695.112Z",
    transform: "translate(726.6 -688.963)",
    fill: "lime"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdnn);
export default __webpack_public_path__ + "static/media/sdnn.0fe6eec549f679ab82504289f6284a17.svg";
export { ForwardRef as ReactComponent };